import script from "./UsuariosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuariosPage.vue?vue&type=script&setup=true&lang=js"

import "./UsuariosPage.vue?vue&type=style&index=0&id=3c0b3676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0b3676"]])

export default __exports__